import * as React from 'react';
import { DefaultButton, PrimaryButton, IStackStyles, MessageBar, MessageBarType, DialogType, DialogFooter, Dialog } from 'office-ui-fabric-react';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Icon, IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import './NewOrderAddItems.scss';
import Header from '../../../common/Header';
import history from '../../../../lib/history';
import { INewOrderAddItemsProps, INewOrderAddItemsState, IOrderDetails, IOrderItem, ISentOrder } from '../../../../interfaces/INewOrderAddItems';
import { ProgressStatus, OrderItemData, MaxOrderItems } from '../../../../constants/GlobalConstants';
import Loader from '../../../common/loader/Loader';
import { _getInputService } from '../../../../services/event.service';
import EditItemPopup from '../edititem/EditItemPopup';
import { setStorage, getStorage, removeStorage } from '../../../../lib/LocalStorageService';
import RemoveConfimationBox from './RemoveConfimationBox';
import { _saveOrderAndItems } from '../../../../services/orderanditem.service';
import ConfimationBox from './ConfimationBox';
import ErrorBar from '../../../common/ErrorBar';
import rand from 'random-key';

const PDFIcon: IIconProps = { iconName: 'PDF', className: 'text-danger ms-fontSize-24' };

export default class NewOrderAddItems extends React.Component<INewOrderAddItemsProps, INewOrderAddItemsState> {

  constructor(props: INewOrderAddItemsProps) {
    super(props);

    const columns: IColumn[] = this.getColumns();

    this.state = {
      ErrorMessage: '',
      ProgressStatus: ProgressStatus.Loaded,
      columns: columns,
      isCompactMode: false,
      OrderDetails: this.getOrderAndItemsDetails(),
      EditItemDetail: {
        Key: '',
        Id: 0,
        Quantity: 0,
        Description: '',
        hideDialog: true,
        ErrorMessageOnQuantity: ''
      },
      RemoveItem: {
        Key: '',
        hideDialog: true,
      },
      SendOrder: {
        isConfirmed: false,
        hideDialog: true,
      },
      CancelOrder: {
        isConfirmed: false,
        hideDialog: true
      },
      SentOrder: undefined
    };

  }

  public componentDidMount() {
    let _orderBasic = null;
    let _historyItems = null;
    let _stateItems = null;
    let _orderDetailRecover: IOrderDetails = JSON.parse(getStorage("OrderDetailRecover"));
    _orderDetailRecover.Items = this.ensureItemKeys(_orderDetailRecover.Items);
   
    const _orderDetails: IOrderDetails = {
      OrderBasic: {
        EventName: _orderDetailRecover.OrderBasic.EventName,
        EventId: _orderDetailRecover.OrderBasic.EventId,
        EventManagerId: _orderDetailRecover.OrderBasic.EventManagerId,
        EventManager: _orderDetailRecover.OrderBasic.EventManager,
        Email_EventManger: _orderDetailRecover.OrderBasic.Email_EventManger,
        Location: _orderDetailRecover.OrderBasic.Location,
        Participant: _orderDetailRecover.OrderBasic.Participant,
      },
      Items: _orderDetailRecover.Items
    };
    this.setState({
      OrderDetails: _orderDetails
    });

  }

  private ensureItemKeys = (items: IOrderItem[]): IOrderItem[] =>
    items.map((item: IOrderItem, index: number) => {
      if (!item.Key) {
        item.Key = rand.generate();
      }
      return item;
    });

  private getOrderAndItemsDetails(): IOrderDetails {

    const _orderDetails: IOrderDetails = {
      OrderBasic: {
        EventName: "",
        EventId: 0,
        EventManagerId: 0,
        EventManager: "",
        Email_EventManger: "",
        Location: "",
        Participant: "",
      },
      Items: []
    };
    return _orderDetails;
  }

  private getColumns(): IColumn[] {
    const columns: IColumn[] = [
      {
        key: 'columnName',
        name: 'Name',
        fieldName: 'name',
        minWidth: 40,
        maxWidth: 40,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        data: 'string',
        onRender: (item: IOrderItem) => {
          return <span className="item-number cursor-pointer" onClick={() => this.editItem(item)}>{item.Quantity}</span>;
        },
        isPadded: true
      },
      {
        key: 'columnItem',
        name: 'Modified by',
        fieldName: 'dateModifiedValue',
        minWidth: 70,
        isResizable: true,
        data: 'number',
        onRender: (item: IOrderItem) => {
          return <div><h6 className="mb-0">{item.Artikelgroep}</h6>
            <p className="mb-0 text-black-50">{item.Title}</p>
            <p className="mb-0 text-black-50">{item.ArticleNumber_MXI}/{item.ArticleNumber_RAI}</p>
            <p>{item.Description}</p>

          </div>;
        },
        isPadded: true
      },
      {
        key: 'columnRecycleBin',
        name: 'Action',
        className: classNames.fileIconCell,
        iconClassName: classNames.fileIconHeaderIcon,
        iconName: 'Remove',
        isIconOnly: true,
        fieldName: 'name',
        minWidth: 16,
        maxWidth: 16,
        onRender: (item: IOrderItem) => {
          return <Icon className="ms-fontSize-24 cursor-pointer" iconName="RecycleBin" onClick={() => this.removeItem(item.Key, false)} />;

        }
      }
    ];
    return columns;
  }

  private _getKey(item: any, index?: number): string {
    return item.key;
  }

  private cancelOrder(_isConfirm: boolean): void {
    const { CancelOrder } = this.state;
    if (CancelOrder.hideDialog == true) {
      this.setState({ CancelOrder: { hideDialog: false, isConfirmed: false } });
    } else {
      this.setState({ CancelOrder: { hideDialog: true, isConfirmed: false } });
      if (_isConfirm) {
        // clear order cache
        removeStorage("OrderDetailRecover");
        removeStorage("NextOrderBasicDetail");
        
        history.push("/dashboard");
      }
    }
  }
  private sendOrderAndItems(_isConfirm: boolean): void {
    const { SendOrder, ErrorMessage } = this.state;
    const { OrderBasic, Items } = this.state.OrderDetails;
    setStorage("OrderDetailRecover", JSON.stringify(this.state.OrderDetails));
    if (SendOrder.hideDialog == true) {
      this.setState({ SendOrder: { hideDialog: false, isConfirmed: false } });
    } else {
      this.setState({ SendOrder: { hideDialog: true, isConfirmed: false } });
      if (_isConfirm) {
        if (Items.length > MaxOrderItems) {
          this.setState({ ErrorMessage: `Er kunnen maar maximaal ${MaxOrderItems} artikelen toegevoegd worden` });
        }
        else {
          try {
            this.setState({ ProgressStatus: ProgressStatus.Loading });
            let _items: any = [];
            Items.forEach(item => {
              let _item = {
                "Amount": item.Quantity,
                "ArticleNumber_MXI": item.ArticleNumber_MXI,
                "ArticleNumber_RAI": item.ArticleNumber_RAI,
                "ItemOrderDescription": item.Description,
                "ArticleDescription": item.Title
              };
              _items.push(_item);
            });
            const bodyData = {
              "EventId": OrderBasic.EventId,
              "EventManagerId": OrderBasic.EventManagerId,
              "Participant": OrderBasic.Participant,
              "Location": OrderBasic.Location,
              "Items": _items
            };

            _saveOrderAndItems(bodyData).then((res: ISentOrder) => {
              if (res.Meerwerkbon_Nr == "" || res.PDF == "") {
                this.setState({ ProgressStatus: ProgressStatus.Loaded, ErrorMessage: res.ReturnMessage });
              } else {
                // clear order cache
                removeStorage("OrderDetailRecover");
                removeStorage("NextOrderBasicDetail");

                this.setState({
                  ProgressStatus: ProgressStatus.Loaded,
                  ErrorMessage: '',
                  SentOrder: res
                });
              }
            });
          } catch (err) {
            console.log(err);
            this.setState({ ProgressStatus: ProgressStatus.Loaded });
          }
        }
      }
    }
  }

  private editItem(item: IOrderItem): void {
    console.log('items', this.state.OrderDetails.Items);
    console.log('edit item id', item.Id);
    console.log('edit item key', item.Key);
    this.setState(prevState => ({
      EditItemDetail: {
        Key: item.Key,
        Id: item.Id,
        Quantity: item.Quantity,
        Description: item.Description,
        hideDialog: false,
        ErrorMessageOnQuantity: ''
      }
    }));
  }

  private removeItem(selectedItemKey: string, isRemove: boolean): void {

    if (isRemove) {
      const items = this.state.OrderDetails.Items.filter(item => item.Key !== selectedItemKey);

      this.setState(prevState => ({
        OrderDetails: {
          OrderBasic: prevState.OrderDetails.OrderBasic,
          Items: [...items]
        },
        RemoveItem: {
          Key: selectedItemKey,
          hideDialog: true
        }
      }));

      setStorage(OrderItemData, JSON.stringify(items));
      setTimeout(() => {
        setStorage("OrderDetailRecover", JSON.stringify(this.state.OrderDetails));
      }, 500);

    } else {
      this.setState({
        RemoveItem: {
          Key: selectedItemKey,
          hideDialog: false
        }
      });
    }
  }

  private cancelRemovingItem = (): void => {
    this.setState(prevState => ({
      RemoveItem: {
        Key: '',
        hideDialog: true
      }
    }));
  }

  private gotoItemCategory(): void {
    let _orderDetailRecover: IOrderDetails = JSON.parse(getStorage("OrderDetailRecover"));
   
    history.push({
      pathname: '/itemcategory',
      state: {
        OrderBasic: _orderDetailRecover.OrderBasic,
        Items: this.state.OrderDetails.Items
      }
    });
  }

  public stackStyles: Partial<IStackStyles> = { root: {} };

  private cancelAdding = (): void => {
    this.setState(prevState => ({
      EditItemDetail: {
        Key: '',
        Id: 0,
        Quantity: 0,
        Description: '',
        hideDialog: true,
        ErrorMessageOnQuantity: ''
      }
    }));
  }

  private submitItem = (): void => {

    const { OrderDetails, EditItemDetail } = this.state;
    if (EditItemDetail.Quantity > 0) {

      let modifiedItems = OrderDetails.Items;
      modifiedItems.forEach(item => {
        if (item.Key == EditItemDetail.Key) {
          item.Quantity = EditItemDetail.Quantity;
          item.Description = EditItemDetail.Description;
        }
      });

      this.setState(prevState => ({
        OrderDetails: {
          OrderBasic: prevState.OrderDetails.OrderBasic,
          Items: [...modifiedItems]
        },
        EditItemDetail: {
          Key: '',
          Id: 0,
          Quantity: 0,
          Description: "",
          hideDialog: true,
          ErrorMessageOnQuantity: ''
        }
      }));
      setStorage(OrderItemData, JSON.stringify(modifiedItems));
      setTimeout(() => {
        setStorage("OrderDetailRecover", JSON.stringify(this.state.OrderDetails));
      }, 500);

    } else {
      this.setState(prevState => ({
        EditItemDetail: {
          Key: prevState.EditItemDetail.Key,
          Id: prevState.EditItemDetail.Id,
          Quantity: prevState.EditItemDetail.Quantity,
          Description: prevState.EditItemDetail.Description,
          hideDialog: prevState.EditItemDetail.hideDialog,
          ErrorMessageOnQuantity: 'Aantal is verplicht'
        }
      }));
    }
  };

  private onTextChangeEvent = (name: string, value: string, data?: any) => {

    let _quntity: number = 0, _errorMessage: string = "";
    if (name == "Quantity") {
      if (Number(value) != NaN && Number(value) > 0) {
        _quntity = Number(value);
        _errorMessage = "";
      } else {
        _quntity = 0;
        _errorMessage = "Aantal is verplicht";
      }
    }

    this.setState(prevState => ({
      EditItemDetail: {
        Key: prevState.EditItemDetail.Key,
        Id: prevState.EditItemDetail.Id,
        Quantity: name == "Quantity" ? _quntity : prevState.EditItemDetail.Quantity,
        Description: name == "Description" ? value : prevState.EditItemDetail.Description,
        hideDialog: prevState.EditItemDetail.hideDialog,
        ErrorMessageOnQuantity: _errorMessage
      }
    }));
  }

  private onHeaderBack = () => {
    let _orderBasic = history.location.state.OrderBasic;
    history.push({
      pathname: '/neworderbasicdetails',
      state: {
        OrderBasic: _orderBasic,
        Items: this.state.OrderDetails.Items
      }
    });

  };

  private onSentOrderDone = () => {
    // reset sent order
    this.setState({
      SentOrder: undefined
    });
    // navigate to dashboard
    history.push("/dashboard");
  }

  public render() {
    const { columns, isCompactMode, OrderDetails, EditItemDetail, CancelOrder, SendOrder, ErrorMessage } = this.state;

    const currentEditItem = this.state.OrderDetails.Items.find(item => item.Id === this.state.EditItemDetail.Id);

    const isItemListFull = OrderDetails.Items.length >= MaxOrderItems;

    return (
      this.state.ProgressStatus != ProgressStatus.Loaded ?
        <Loader PageTitle="<b>Meerwerkbon details</b> aan het verzenden" /> :
        this.state.SentOrder ?
          <Dialog
            hidden={false}
            dialogContentProps={{
              type: DialogType.normal,
              title: "Meerwerkbon is verzonden",
              subText: `Verzonden naar ${this.state.OrderDetails.OrderBasic.Email_EventManger}`
            }}
            modalProps={{
              isBlocking: true,
              onDismiss: this.onSentOrderDone,
              styles: { main: { maxWidth: 450 } }
            }}
          >
            <DialogFooter>
              <PrimaryButton
                onClick={this.onSentOrderDone}
                text="Gereed" />
            </DialogFooter>
          </Dialog>
          :
          <div className="page pb-5">
            <Header isBackVisible={true} _onBack={this.onHeaderBack} />
            <ErrorBar
              ErrorMessage={ErrorMessage}
              _onDismiss={() => this.setState({ ErrorMessage: '' })}
            />

            <div className="container mt-3">
              <div className="ms-Grid">
                <div className="ms-Grid-row">
                  <div className="ms-Grid form-group">
                    <div className="row font-weight-bold">
                      <div className="col-5 col-md-3">
                        <span>Event:</span>
                      </div>
                      <div className="col-7 col-md-3">
                        <span>{OrderDetails.OrderBasic.EventName}</span>
                      </div>
                      <div className="col-5 col-md-3">
                        <span>Event manager:</span>
                      </div>
                      <div className="col-7 col-md-3">
                        <span className="d-inline-block pr-2">{OrderDetails.OrderBasic.EventManager}</span>
                        <span className="d-inline-block">({OrderDetails.OrderBasic.Email_EventManger})</span>
                      </div>
                      <div className="col-5 col-md-3">
                        <span>Deelnemer:</span>
                      </div>
                      <div className="col-7 col-md-3">
                        <span>{OrderDetails.OrderBasic.Participant}</span>
                      </div>
                      <div className="col-5 col-md-3">
                        <span>Locatie:</span>
                      </div>
                      <div className="col-7 col-md-3">
                        <span>{OrderDetails.OrderBasic.Location}</span>
                      </div>
                      <div className="col-9 mt-4 text-center">
                        <h3>Artikelen</h3>
                      </div>
                      <div className="col-3 mt-4 text-right">
                        <IconButton iconProps={{ iconName: 'CircleAdditionSolid', className: "add-items" }} title="Voeg artikel toe"
                          disabled={isItemListFull}
                          ariaLabel="Voeg artikel toe" onClick={this.gotoItemCategory.bind(this)} />
                      </div>
                      {
                        isItemListFull &&
                        <div className="col-12 mt-4 text-center">
                          <MessageBar messageBarType={MessageBarType.info}>Er kunnen maar maximaal {MaxOrderItems} artikelen toegevoegd worden</MessageBar>
                        </div>
                      }
                      <div className="col-12 mt-3">
                        <DetailsList
                          items={OrderDetails.Items}
                          compact={isCompactMode}
                          columns={columns}
                          selectionMode={SelectionMode.none}
                          getKey={this._getKey}
                          setKey="none"
                          layoutMode={DetailsListLayoutMode.justified}
                          isHeaderVisible={false}
                        />
                        {
                          OrderDetails.Items.length === 0 &&
                          <MessageBar messageBarType={MessageBarType.info}>Voeg artikelen toe om de meerwerkbon te kunnen versturen</MessageBar>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom-btns">
              <div className="container">
                {
                  ErrorMessage &&                  
                    <ErrorBar
                    ErrorMessage={ErrorMessage}
                    _onDismiss={() => this.setState({ ErrorMessage: '' })}
                  />
                }
                <div className="row justify-content-between">
                  <DefaultButton className="btn-outline-danger" text="Annuleer bon" onClick={() => this.cancelOrder(false)} allowDisabledFocus />
                  <PrimaryButton text="Verzenden"
                    onClick={() => this.sendOrderAndItems(false)}
                    disabled={OrderDetails.Items.length === 0}
                    allowDisabledFocus />
                </div>
              </div>
            </div>
            <EditItemPopup
              Key={this.state.EditItemDetail.Key}
              Id={this.state.EditItemDetail.Id}
              ItemTitle={currentEditItem ? currentEditItem.Title : ""}
              ItemCategoryTitle={currentEditItem ? currentEditItem.Artikelgroep : ""}
              ItemNo_MXI={currentEditItem ? currentEditItem.ArticleNumber_MXI : 0}
              ItemNo_RAI={currentEditItem ? currentEditItem.ArticleNumber_RAI : 0}
              Quantity={this.state.EditItemDetail.Quantity}
              Description={this.state.EditItemDetail.Description}
              ErrorMessageOnQuantity={this.state.EditItemDetail.ErrorMessageOnQuantity}
              hideDialog={this.state.EditItemDetail.hideDialog}
              _onTextChangeEvent={this.onTextChangeEvent}
              _submitData={this.submitItem}
              _cancel={this.cancelAdding}
            />
            <RemoveConfimationBox
              selectedItemKey={this.state.RemoveItem.Key}
              isRemoved={true}
              hideDialog={this.state.RemoveItem.hideDialog}
              _removeItem={this.removeItem.bind(this)}
              _cancel={this.cancelRemovingItem}
            />

            <ConfimationBox
              isConfirmed={CancelOrder.isConfirmed}
              title="Meerwerkbon annuleren?"
              subTitle="Alle gegevens zullen verloren gaan"
              noText="Nee"
              yesText="Ja"
              hideDialog={CancelOrder.hideDialog}
              _yes={() => this.cancelOrder(true)}
              _no={() => this.cancelOrder(false)}
            />
            <ConfimationBox
              isConfirmed={SendOrder.isConfirmed}
              title="Meerwerkbon verzenden?"
              noText="Nee"
              yesText="Ja"
              hideDialog={SendOrder.hideDialog}
              _yes={() => this.sendOrderAndItems(true)}
              _no={() => this.sendOrderAndItems(false)}
            >
              <div>Event manager: {OrderDetails.OrderBasic.EventManager}</div>
              <div>E-mail: {OrderDetails.OrderBasic.Email_EventManger}</div>
            </ConfimationBox>
          </div>
    );
  }
}

const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: '16px'
  },
  fileIconCell: {
    textAlign: 'right',
    selectors: {
      '&:before': {
        content: '.',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0px',
        visibility: 'hidden'
      }
    }
  },
  fileIconImg: {
    verticalAlign: 'middle',
    maxHeight: '16px',
    maxWidth: '16px'
  },
  controlWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  exampleToggle: {
    display: 'inline-block',
    marginBottom: '10px',
    marginRight: '30px'
  },
  selectionDetails: {
    marginBottom: '20px'
  }
});
